import { z } from 'zod';

export const BusinessAreaResponse = z.object({
  id: z.string(),
  name: z.string(),
  services: z.array(z.string()),
  enableAdvancedPriceManagement: z.boolean(),
  description: z.string(),
});

export type TBusinessAreaResponse = z.infer<typeof BusinessAreaResponse>;
